module.exports = __webpack_public_path__ + "files/4a480382b1bb8a8a7768e82a47b4f0ba.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/generic.svg
// module id = 584
// module chunks = 27